import { buildJobListingsUrl } from "@workspace/dto/email/destinations";
import { z } from "zod";
import { buildFromAddress } from "../utils/build-email-address";
import {
  defineEmailNotificationHandler,
  requireOrganizationId,
  resolveWorkplaceName,
} from "./types";

const ApplicationRejectedSchema = z.object({
  applicationId: z.string(),
  jobId: z.string(),
  jobTitle: z.string(),
  companyName: z.string().optional(),
});

export const applicationRejectedHandler = defineEmailNotificationHandler({
  type: "application.rejected",
  icon: "application",
  title() {
    return "Application update";
  },
  description(metadata) {
    const jobTitle =
      typeof metadata.jobTitle === "string" && metadata.jobTitle.trim()
        ? metadata.jobTitle
        : undefined;
    const companyName =
      typeof metadata.companyName === "string" && metadata.companyName.trim()
        ? metadata.companyName
        : undefined;
    return jobTitle
      ? `${companyName ?? "An employer"} has updated your application for ${jobTitle}.`
      : "An employer has updated your application.";
  },
  schema: ApplicationRejectedSchema,
  buildNotificationPayload(data, _ctx) {
    return {
      metadata: {
        applicationId: data.applicationId,
        jobId: data.jobId,
        jobTitle: data.jobTitle,
        companyName: data.companyName,
      },
      links: {
        href: "/job-listings",
        label: "Find jobs",
      },
    };
  },
  buildEmailPayload(
    data,
    recipient,
    { baseUrl, organizationId, unsubscribeUrl }
  ) {
    return {
      name: "email/application.rejected",
      data: {
        organizationId: requireOrganizationId({ organizationId }),
        to: recipient.email,
        from: buildFromAddress(),
        recipientName: recipient.name,
        workplaceName: resolveWorkplaceName(data.companyName),
        jobTitle: data.jobTitle,
        jobListingsUrl: buildJobListingsUrl(baseUrl),
        unsubscribeUrl,
      },
    };
  },
});
